import { EventAttribute } from '../../services/eventAttributesService/eventAttributesService';

export const GET_EVENT_ATTRIBUTES_REQUEST = 'GET_EVENT_ATTRIBUTES_REQUEST';
export const GET_EVENT_ATTRIBUTES_SUCCESS = 'GET_EVENT_ATTRIBUTES_SUCCESS';
export const GET_EVENT_ATTRIBUTES_FAILURE = 'GET_EVENT_ATTRIBUTES_FAILURE';

export interface EventAttributesState {
  eventAttribute: EventAttribute | null;
  loading: boolean;
  error: string | null;
}

export interface GetEventAttributesRequestAction {
  type: typeof GET_EVENT_ATTRIBUTES_REQUEST;
  payload: string; // eventName
  [key: string]: any;
}

export interface GetEventAttributesSuccessAction {
  type: typeof GET_EVENT_ATTRIBUTES_SUCCESS;
  payload: EventAttribute;
  [key: string]: any;
}

export interface GetEventAttributesFailureAction {
  type: typeof GET_EVENT_ATTRIBUTES_FAILURE;
  payload: string;
  [key: string]: any;
}

export type EventAttributesActionTypes =
  | GetEventAttributesRequestAction
  | GetEventAttributesSuccessAction
  | GetEventAttributesFailureAction;
